import { render, staticRenderFns } from "./CloseImg.vue?vue&type=template&id=195cedba&"
import script from "./CloseImg.vue?vue&type=script&lang=js&"
export * from "./CloseImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports